export default __webpack_public_path__ + "static/media/bg.9c266f0c.jpg";